/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Image, Modal, Spin, Tabs, Tooltip, } from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  PlusCircleFilled,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { ImFolderDownload } from 'react-icons/im'
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { MailOutlined } from "@ant-design/icons";
import confirm from "antd/lib/modal/confirm";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { SignableAndReadOnly } from "../../Common/components/SignableAndReadOnly";
import axios from "axios";
import { VscNewFolder } from 'react-icons/vsc';
import { RiFolderSharedFill } from "react-icons/ri";
import { getBuildDataForCustomerdocs } from "../../CreateOffer/features/helperFunctions";
import { checkIfDisabled, createOfferContractTypes, customerDocsContractTypes, disabledTransactionText, listingContractTypes } from "../../Common/commondata/commonData";
import { changeExtensiontoLowerCase } from "../../Common/utils/ExtraFunctions";
import CreateFolderModal from "./CreateFolderModal";
import MoveToFolder from "./MoveToFolder";
import PropertyDocsTable from "./PropertyDocsTable";
import CreateDocs from "./CreateDocs";
import { transactionLaneDataHandle } from "../state/actions";
import { contractDataHandle } from "../../CreateOffer/state/actions";
import { DraggerComp } from "../../Common/components/DraggerComp";
import EditNameModal from "../../Common/components/EditNameModal";
import ReSureSignDocs  from "./ReSureSignDocs";
import ResureSign from "../../Assets/Icons/Resure_icon.png";

const {TabPane} = Tabs

const PropertyDocsModal = ({ isModalOpen, setIsModalOpen, role, section, item, isWeb, tags, userAuthKey, allBuyerAgentData, formattedId  }) => {
  const delegate = (section === "DELEGATE");
  let { propertyDocs, propertDocsLoading, propertDocsError, updatedPropertyDoc, uploadedPdfDocSuccess, moveToFolderData, moveToFolderDataLoading, zipDownloadLoading, propertyDocsWithoutSection } = useSelector((state) => state.rtdTransactionLane,shallowEqual);
  const isSmallScreen = useMediaQuery({ maxWidth: 480 });
  const scrollRequired = useMediaQuery({ maxWidth: 690 });
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const uploadFile = useRef("");
  // const agentDetails = (item?.isProperty) ? (item?.currentSellerAgentId) : item?.currentBuyerAgentId;
  const agentDetails = (item?.currentAgentId);
  const {filterSort} = useSelector((state) => state.rtdTransactionLane);
  const [currentPropertyDocId, setCurrentPropertyDocId] = useState({
    clickedItem: "",
    source: "",
  });
  const [checkedDocs, setCheckedDocs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nestedModalOpen, setNestedModalOpen] = useState({
    isUploadDocsModal: false,
    isEmailModalOpen: false,
    isLegendOpen: false,
    sendMultipleDoc:false,
    isclearTransactionLaneData:false,
    isEditNameModalOpen: false,
    editDocDetails: {},
    resureSignDoc:false
  });
  const [page, setPage] = useState([1]);
  const [createFolderModalOpen, setCreateFolderModalOpen] = useState({
    createFolder: false
  });
  const [moveFolderModalOpen, setMoveFolderModalOpen] = useState(false);
  const [folderName, setFolderName] = useState();
  const [propertyDocsWithType, setPropertyDocsWithType] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState({
    offerDocs:[],
    propertyDocs:[],
    resureSignDocs:[]
});
const [form] = Form.useForm();

  const [tabSelect, setTabSelect] = useState("1");


  let unmounted = {
    value: false
  };
  let source = axios.CancelToken.source();

  useEffect(()=>{
    const params = {
      ...(item?.offerId ? { offerId: item?.offerId } : {}),
      ...(item?.propertyId  ? { propertyId: item?.propertyId } : {}),
      openFor: "SELLER_AGENT",
      ...(delegate ? {delegateSide: (item.isProperty)? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id} : {}),
     section: "PROPERTY_DOCS",
     ...(isWeb ? {isWeb: true, queryPlatform: "WEB"} : {})
    };
    if (item?.offerId || item?.propertyId) {
      dispatch(contractDataHandle.getPropertyDocsFun({ params, unmounted, source, contractAuthKey: userAuthKey }));
    }
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    }
  }, [updatedPropertyDoc, uploadedPdfDocSuccess])

  useEffect(() => {
    const delegateSide = section === "DELEGATE" && role;
    if (item?.offerId || item?.propertyId) {
      dispatch(transactionLaneDataHandle.getIndividualTransaction({ offerId:item?.offerId, setLoading, unmounted, source, userAuthKey, openFor: "SELLER_AGENT" }));
    }
    return () => {
      unmounted.value = true;
      source.cancel("Cancelling in cleanup");
    };
  }, []);
  // Property Docs functions
  const handleActivePropertyDocsOk = () => {
    setIsModalOpen({ ...isModalOpen, propertyDocs: false });
    dispatch(transactionLaneDataHandle.resetFolderOpenState());
  };

  const handleActivePropertyDocsCancel = () => {
    setIsModalOpen({ ...isModalOpen, propertyDocs: false });
    dispatch(transactionLaneDataHandle.resetFolderOpenState());
   };

  const handleuploadmodal = () => {
    setNestedModalOpen({ ...nestedModalOpen, isUploadDocsModal: true });
  //   const type="SendEmail"
  //   const params = {
  //     ...(item?.offerId ? { offerId: item?.offerId } : {}),
  //     ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
  //     openFor: "SELLER_AGENT",
  //     personId: agentDetails?._id,
  //     ...(delegate ? {delegateSide: (item.isProperty)? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id} : {}),
  //   };
  //   dispatch(contractDataHandle.getPropertyDocsFun({params, unmounted, source,type, contractAuthKey: userAuthKey}));
  //  return () => {
  //     unmounted.value = true;
  //     source.cancel("Cancelling in cleanup");
  //   }
  };

  const handleCreateAmendExtend = ({ parentDoc, docSecondItem }) => {
    try {
      const officeDetails = {
        officeLogo: agentDetails?.brokerageData?.logo || "",
        name: agentDetails?.brokerageData?.name?.trim() || "",
        address: agentDetails?.brokerageData?.address || "",
        agentId: agentDetails?._id,
      };
      const buildData = getBuildDataForCustomerdocs({clientDocId: parentDoc?._id,  contractType: docSecondItem?.contractType, contractId: docSecondItem?.contractId, currentAgentDetails: agentDetails, transactionData: parentDoc.transactionData, delegate, item, officeDetails, docSecondItem, userAuthKey });
      // console.log("buildData", buildData);
      dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({ buildData, history }));
    } catch (error) {
      
    }
  };

  const handleCancel = () => {
    setCheckedDocs([]);
    setNestedModalOpen({
      ...nestedModalOpen,
      resureSignDoc: false,
      isUploadDocsModal: false,
    });
  };
  // ---------------  functions to open the files ---------------------
  const handlePropertyDocs = (eachDoc = {}) => {
    if (typeof eachDoc !== "object") return;
    if (eachDoc.isPdf || eachDoc.pdfLink || eachDoc.resureSignedPdfLink) {
      eachDoc.resureSignedPdfLink ? window.open(eachDoc.resureSignedPdfLink, "_blank") :  window.open(eachDoc.pdfLink, "_blank");
    } else if (eachDoc.fileType === "IMAGE" || eachDoc.fileType === "PDF") {
      if (eachDoc?.fileUrl) {
        window.open(eachDoc?.fileUrl);
      }
    } else if (eachDoc.isResureSignDoc) {
      let buildData = {
        documentId: eachDoc.documentId,
        ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
        ...(item?.offerId && !item.isSellingMatrix ? { offerId: item.offerId } : {}),
      };
      dispatch(transactionLaneDataHandle.generateresureSignUrl({ buildData,userAuthKey }));
    }else {
      const isCustomerDoc = customerDocsContractTypes.includes(eachDoc.contractType);
      let buildData = {
        documentId: eachDoc.documentId,
        contractType: eachDoc.contractType,
        contractId: eachDoc.contractId,
        // openFor: isCustomerDoc ? (eachDoc.RTDInitiator === "BUYER" ? "BUYER_AGENT" : "SELLER_AGENT") : item?.isProperty ? "SELLER_AGENT" : "BUYER_AGENT",
        openFor:"SELLER_AGENT",
        token: userAuthKey,
        builtForId: agentDetails?._id,
        key: agentDetails?._id,
        ...(item?.offerId && !isCustomerDoc ? { offerId: item.offerId } : {}),
        ...(delegate ? { delegateOwnerId: agentDetails?._id } : {}),
        builtForSection: "DOCUMENT",
        signable: true,
        ...(eachDoc.RTDInitiator && { RTDInitiator: eachDoc.RTDInitiator }),
        ...(item?.propertyId && !isCustomerDoc ? { propertyId: item?.propertyId } : {}),
      };
      localStorage.setItem("openModal",JSON.stringify(true));
      dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({ buildData, history }));
    }
  };

  const handleOPenDocs = (ele) => {
    if (ele?.fileUrl) {
      window.open(ele?.fileUrl);
    }
  };

  const handleShareUnshareFileConfirm = (ele, checkBoxValue) => {
    confirm({
      title: checkBoxValue ? "Are you sure you want to share this file in the Transaction Dashboard?" : "Are you sure you want to remove this file from the Transaction Dashboard?",
      content: checkBoxValue ? "Note: Sharing this file in the Transaction Dashboard will automatically make it available to the opposite agent's Transaction Dashboard." : "Note: Removing this file from the Transaction Dashboard will automatically make it unavailable to the opposite agent's Transaction Dashboard.",
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined style={{ color: "orange" }} />,
      onOk() {
        handleShared(ele);
      },
      onCancel() {},
    });
  };

// The common function used in handleconfirm & handleconfirm2
  const handleShared = (ele) => {
    const params = {
      ...(item?._id ? { propertyDocId: ele._id } : {}),
      ...(item?.offerId ? { offerId: item?.offerId } : {}),
      ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
      ...(ele.isShared ? { unShare: "true" } : {}),
      ...(delegate ? {delegateSide: (item.isProperty)? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id} : {}),
    };

    if (item?.offerId) {
      dispatch(transactionLaneDataHandle.sharePropertyDocs(params, true, userAuthKey));
    } else {
      dispatch(transactionLaneDataHandle.sharePropertyDocs(params, true, userAuthKey));
    }
  };

//   Function to Upload doc will be passed as prop
const uploadTemp = (uploadedFilesInfo) => {
    
  const payload = {
       fileLinks: uploadedFilesInfo, // must be an array of { fileLink, fileName, fileType }
       personId: agentDetails?._id,
       openFor:"SELLER_AGENT",
       folderOf: "property_docs",
     };
   
     if (item?.offerId) {
       payload.offerId = item.offerId;
     }
   
     if (delegate) {
       payload.delegateSide = "SELLER";
       payload.delegateOwnerId = agentDetails?._id;
     } 
   
     if (item?.isProperty) {
       payload.propertyId = item._id;
     }
   
     dispatch(transactionLaneDataHandle.uploadPropertyDocsFun(payload, userAuthKey));
   
     setNestedModalOpen({ ...nestedModalOpen, isUploadDocsModal: false });
  };

  const checkForDisable = checkIfDisabled({openFor:  "SELLER" , actualPropertyStatus: item?.actualPropertyStatus, buyingStatus: item?.actualOfferStatus, offerStatus: item?.status});

  const handleCreateDocCancel = () => {
    setNestedModalOpen({ ...nestedModalOpen, isUploadDocsModal: false })
  }
  // Function To Delete Document from propertyDocs folder

const handleDeletePropertyDocs = (ele, docType) => {
  // Determine the message and content based on requiresWholeReRender
  const isWholeReRenderRequired = listingContractTypes.includes(ele.contractType) || createOfferContractTypes.includes(ele.contractType);
  
  const confirmationMessage = isWholeReRenderRequired
    ? (
      <>
        Are you sure you want to delete this <span style={{ color: 'red' }}>{ele?.contractType}</span> document? This action will affect all other documents
      </>
    )
    : `Are you sure you want to ${ele?.isResureSignDoc?"remove":"delete"} this document?`;
  
    const confirmationContent = ele?.isResureSignDoc ? "Note: This action is irreversible. The document will be permanently removed from your account." : isWholeReRenderRequired ? "Note: This action is irreversible. Deleting this document will permanently remove it from your account and all associated documents." : "Note: This action is irreversible. Deleting this document will permanently remove it from your account.";
  confirm({
    title: confirmationMessage,
    content: confirmationContent,
    okText: "Yes",
    cancelText: "No",
    icon: <ExclamationCircleOutlined style={{  color: "orange" }} />,
    onOk() {
   if (ele.isCustomerDoc) {
      dispatch(transactionLaneDataHandle.deleteListing({ docId: ele._id, source:"PROPERTY_CLIENT_DOCS", userAuthKey }));
  } else if (docType === 'uploadedDoc') {
        dispatch(transactionLaneDataHandle.removePropertyDocsFun(ele?._id, userAuthKey));
      } else if (docType === 'contractDoc') {
        const payloadData = {
          documentId: ele?.documentId,
          ...(delegate ? {delegateSide: (item.isProperty)? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id} : {}),
          ...(item?.propertyId && { propertyId: item?.propertyId }),
          // ...(item?.offerId && { offerId: item?.offerId }),
          section : "PROPERTY_DOCS",
          requiresRender: true,
          requiresWholeReRender: isWholeReRenderRequired,
          ...(ele?.isResureSignDoc && { isResureSignDoc:true}),
          filterSort
        };
        dispatch(transactionLaneDataHandle.deletePropertyContractDocsFun({ payloadData, userAuthKey }));
      }
    },
    onCancel() {},
  });
};

  const handleToggleDashboard = (ele, checkBoxValue) => {
   
    const payloadData = {
      documentId: ele?.documentId,
      isToggleFrom: "PROPERTY_DOCS",
      ...(ele?.isResureSignDoc && { isResureSignDoc: true }),
      ...(delegate ? {delegateSide: (item.isProperty)? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id} : {}),
      ...(item?.propertyId && { propertyId: item?.propertyId }),
      // ...(item?.offerId && { offerId: item?.offerId }),
      requiresRender: true,
      showInTransactionDashboard: checkBoxValue
    };
    confirm({
      title: checkBoxValue
        ? `Are you sure you want to move this document in the Transaction Dashboard?`
        : `Are you sure you want to remove this document from the Transaction Dashboard?`,
      okText: "Yes",
      cancelText: "No",
      content: ele?.isResureSignDoc && checkBoxValue ? (
        <div style={{ marginTop: 8, color: "rgba(0, 0, 0, 0.65)" }}>
          Note: Sharing a RE-Sure Sign document in the Transaction Dashboard will automatically make it available to the opposite agent's Transaction Dashboard.
        </div>
      ) : null,
      icon: <ExclamationCircleOutlined  style={{  color: "orange" }}/>,
      onOk() {
        dispatch(transactionLaneDataHandle.toggleDocumentInTransactionDashboard({ payloadData, userAuthKey, openFor: "SELLER_AGENT" }));
      },
      onCancel() { },
    });
  };

  const handleOpenMoveToFolder = () => {

    setMoveFolderModalOpen(true)
    const params = {
      ...(item?.offerId ? { offerId: item?.offerId } : {}),
      ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
      openFor:  "SELLER_AGENT",
      ...(delegate ? { delegateSide: (item?.isProperty || item?.isErts) ? "SELLER" : "BUYER", delegateOwnerId: agentDetails?._id } : {}),
      section: "PROPERTY_DOCS",
      // personId: agentDetails?._id,
    };
    dispatch(transactionLaneDataHandle.getMoveToFolderFun({ params, userAuthKey }))
  }

  const downloadAllFilesAsZip = () => {
    let documentDetails = [];
    const processDocument = (doc, parentPath = "") => {
      if (!doc || typeof doc !== "object") return; // Handle null or invalid docs
    
      const docName = doc.documentName || doc.fileName || doc.name || "Unnamed Document";
    
      // Compute full parent path for nesting
      const currentPath = parentPath ? `${parentPath} > ${docName}` : docName;
    
      try {
        // Handle IMAGE / PDF files
        if (["IMAGE", "PDF"].includes(doc?.fileType) && doc?.storageType === "FILE") {
          documentDetails.push({
            type: doc.fileType,
            link: doc.fileUrl || "",
            fileName: docName,
            parentFolder: parentPath || null,
            ...(["PDF"].includes(doc?.fileType) && doc?.contractType ? {contractType: doc?.contractType} : {}),
          });
          return;
        }
    
        // Handle customer PDF documents
        if ((doc.isCustomerDoc && doc.isPdf) && doc.storageType === "FILE") {
          documentDetails.push({
            type: "PDF",
            link: doc.pdfLink || "",
            fileName: docName,
            parentFolder: parentPath || null,
            ...(doc?.contractType ? {contractType: doc?.contractType} : {}),

          });
          return;
        }
    
        // Handle general DOCUMENT files
        if (!doc.isPdf && (doc.documentId || doc._id) && doc.storageType === "FILE") {
          documentDetails.push({
            type: "DOCUMENT",
            documentId: doc?.documentId || doc?._id,
            documentName: docName,
            contractId: doc?.contractId,
            contractType: doc?.contractType || '',
            parentFolder: parentPath || null,
            RTDInitiator: doc?.RTDInitiator,
          });

          // Handle secondary linked documents (matchedDocuments)
          if (Array.isArray(doc.matchedDocuments) && doc.matchedDocuments.length > 0) {
            doc.matchedDocuments.forEach((matchedDocumentItem) => {
              if (!matchedDocumentItem) return;
              const matchedDocName = matchedDocumentItem.documentName || matchedDocumentItem.fileName || matchedDocumentItem.name || '';
              documentDetails.push({
                type: "DOCUMENT",
                documentId: matchedDocumentItem.documentId || matchedDocumentItem._id,
                contractType: matchedDocumentItem.contractType || '',
                contractId: matchedDocumentItem?.contractId,
                documentName: matchedDocName,
                parentFolder: parentPath || null,
                RTDInitiator: doc?.RTDInitiator,
              });
            });
          }
          return;
        }
    
        // Handle folders and nested items
        if (doc.storageType === "FOLDER" && Array.isArray(doc.nestedItems) && doc.nestedItems.length > 0) {
          doc.nestedItems.forEach((nestedItem) => processDocument(nestedItem, currentPath));
        }
      } catch (error) {
        console.error("Error processing document:", doc, "Error:", error);
      }
    };
    
    // Process all propertyDocs
    if (Array.isArray(propertyDocsWithoutSection) && propertyDocsWithoutSection?.length > 0) {
      propertyDocsWithoutSection?.forEach((doc) => processDocument(doc));
    }    

    const payload = {
      ...(item?.offerId ? { offerId: item?.offerId } : {}),
      ...(item?.propertyId ? { propertyId: item?.propertyId } : {}),
      documentDetails,
      openFor: "SELLER_AGENT",
      section: "PROPERTY_DOCS",
    };
    dispatch(transactionLaneDataHandle.downloadAllFilesAsZip({ payload, userAuthKey }));
  }

  const handleEditName = (item) => {
    setNestedModalOpen({...nestedModalOpen, isEditNameModalOpen: true, editDocDetails: item})
  }

  const sellerAgentIdsArray =(item?.sellerAgentIds || []).map((el) => String(el._id));
  
  const buyerAgentIdsArray =(item?.buyerAgentIds || []).map((el) => String(el._id));
  
  return (
    <>
      {createFolderModalOpen?.createFolder && <CreateFolderModal setCreateFolderModalOpen={setCreateFolderModalOpen} createFolderModalOpen={createFolderModalOpen} getCoordinateItem={item} delegate={delegate} agentDetails={agentDetails} setFolderName={setFolderName} subFolder={false} userAuthKey={userAuthKey} />}

      {nestedModalOpen?.isEditNameModalOpen && <EditNameModal nestedModalOpen={nestedModalOpen} setNestedModalOpen={setNestedModalOpen} form={form} userAuthKey={userAuthKey} />}

      {/* Move To Folder Modal */}
      {moveFolderModalOpen && <Modal
        title={<span style={{ display: "flex", justifyContent: "center", color: "#178DFA", fontWeight: "bold", fontSize: "22px" }}>Move to Folder</span>}
        visible={moveFolderModalOpen}
        onCancel={() => setMoveFolderModalOpen(false)}
        footer={null}
      >
        <MoveToFolder setMoveFolderModalOpen={setMoveFolderModalOpen} moveToFolderData={moveToFolderData} moveToFolderDataLoading={moveToFolderDataLoading} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} getCoordinateItem={item} userAuthKey={userAuthKey} />
      </Modal>}
      
      {/* Main property docs modal  */}
      <Modal
        style={{ top: "20px", height: "500px" }}
        width={750}
        title={
          <div
            className="documentModal"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "grey",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            <div style={{ width: "10%", textAlign: "left", cursor: "pointer" }}>
              <Tooltip title="Create New Folder" placement="top">
                <VscNewFolder
                  style={{
                    fontSize: isSmallScreen ? "20px" : "25px",
                    color: "rgb(8,81,145)",
                  }}
                  onClick={() => setCreateFolderModalOpen({...createFolderModalOpen,createFolder:true})}
                />
              </Tooltip>
            </div>
            <div style={{ width: "10%", cursor: "pointer" }}>
              <Tooltip title="Move to Folder" placement="top">
                <RiFolderSharedFill
                  style={{
                    fontSize: isSmallScreen ? "20px" : "27px",
                    color: "rgb(8,81,145)",
                    marginLeft: isSmallScreen ? "5px" : "",
                  }}
                  onClick={handleOpenMoveToFolder}
                />
              </Tooltip>
            </div>
            <div style={{ width: "90%", textAlign: "center", fontSize: isSmallScreen ? "15px" : "20px", color: "#178DFA" }}>
              Property Docs
            </div>
            <div
              style={{
                width: isSmallScreen ? "28%" : "24%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: isSmallScreen ? "10px" : "20px",
                marginRight: "10px",
              }}
            >
              {/* <div>
                {propertDocsLoading || zipDownloadLoading ? <div><Spin size="small"></Spin></div> : !propertDocsLoading && !propertDocsError && propertyDocsWithoutSection?.length > 0 &&
                  <Tooltip title="Download All files as Zip" placement="top">
                    <ImFolderDownload style={{ opacity: 1, color: '#1890ff', cursor: "pointer" }} size={isSmallScreen ? 16 : 24} onClick={downloadAllFilesAsZip} />
                  </Tooltip>
                }
              </div> */}
              {/* <Button
                onClick={() =>
                  setNestedModalOpen({
                    ...nestedModalOpen,
                    resureSignDoc: true,
                  })
                }
                icon={
                  <Tooltip title="RE-Sure Sign Documents" placement="top">
                    <FormOutlined style={{ fontSize: isSmallScreen ? "16px" : "25px" }} />
                  </Tooltip>
                }
                style={{
                  color: "#085191",
                  border: "none",
                }}
              /> */}
              <Button
                onClick={() =>
                  setNestedModalOpen({
                    ...nestedModalOpen,
                    sendMultipleDoc: true,
                    isEmailModalOpen: true,
                  })
                }
                icon={
                  <MailOutlined
                    style={{ fontSize: isSmallScreen ? "16px" : "25px" }}
                  />
                }
                style={{
                  color: "#085191",
                  border: "none",
                }}
              />
              <Button
                className="borderless-button"
                style={{ border: 0 }}
                icon={
                  <PlusCircleFilled
                    style={{
                      fontSize: isSmallScreen ? "16px" : "25px",
                      color: "#085191",
                      marginLeft:isSmallScreen ? "-16px" : "-25px"
                    }}
                    {...(checkForDisable?.disabled
                      ? { onClick: disabledTransactionText }
                      : { onClick: () => handleuploadmodal() })}
                  />
                }
              />
            </div>
          </div>
        }
        footer={false}
        visible={isModalOpen?.propertyDocs}
        onOk={handleActivePropertyDocsOk}
        onCancel={handleActivePropertyDocsCancel}
        className="documentModal"
      >
        <div style={{ height: "500px", marginTop:"-20px" }} className="documentModal">
          {propertDocsLoading ? (
            <div style={{ width: "100%", fontSize: "15px", height: "40%", paddingTop: "10%", textAlign: "center" }}>
              <Spin />
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                color: "black",
                height: "100%" ,
                overflowY: "auto",
                overflowX: scrollRequired ? "auto" : "hidden",
                paddingRight: "5px",
              }}
            >
              <PropertyDocsTable
                propertyDocs= {propertyDocsWithoutSection}
                propertyDocsWithType= {propertyDocsWithType}
                setPropertyDocsWithType= {setPropertyDocsWithType}
                role={role}
                item={item}
                handleOPenDocs={handleOPenDocs}
                handlePropertyDocs={handlePropertyDocs}
                handleShareUnshareFileConfirm={handleShareUnshareFileConfirm}
                handleToggleDashboard={handleToggleDashboard}
                handleDeletePropertyDocs={handleDeletePropertyDocs}
                isSmallScreen={isSmallScreen}
                folderName= {folderName}
                setFolderName= {setFolderName}
                delegate={delegate}
                setCreateFolderModalOpen={setCreateFolderModalOpen}
                createFolderModalOpen={createFolderModalOpen}
                agentDetails={agentDetails}
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                handleCreateAmendExtend={handleCreateAmendExtend}
                userAuthKey={userAuthKey}
                handleEditName={handleEditName}
              />
            </div>
          )}
        </div>
      </Modal>
      {/* //resure sign modal */}
      {/* {nestedModalOpen?.resureSignDoc && (
        <Modal width={800} visible={nestedModalOpen?.resureSignDoc}
         footer={false} onCancel={handleCancel} bodyStyle={{ marginTop: "-30px",height: "600px"  }}>
          <ReSureSignDocs
            setNestedModalOpen={setNestedModalOpen}
            nestedModalOpen={nestedModalOpen}
            propertyId={item?.propertyId}
            offerId={!item?.isSellingMatrix ? item?.offerId :null}
            RTDInitiator={"SELLER"}
            isSellingMatrix={item?.isSellingMatrix}
            handleCancel={handleCancel}
           checkedDocs={checkedDocs}
           setCheckedDocs ={setCheckedDocs}
            buyerAgentIds={buyerAgentIdsArray}
            sellerAgentIds={sellerAgentIdsArray}
            isWeb={isWeb}
            delegate={
              delegate && {
                delegateSide: item?.isProperty ? "SELLER" : "BUYER",
                delegateOwnerId: agentDetails?._id,
              }
            }
            userAuthKey={userAuthKey}
          />
        </Modal>
      )} */}
      {/* upload docs modal here  */}
       <Modal
          width={800}
          visible={nestedModalOpen?.isUploadDocsModal}
          footer={false}
          onCancel={handleCreateDocCancel}
          style={{marginTop: "-50px"}}
        >
          <div
            style={{
              textAlign: "center",
              color: "#888888",
              height: "82vh",
              fontSize: "18px",
              padding: "5px",
              marginTop: "10px",
              // boxShadow:
              //   "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
              // borderTopLeftRadius: "5px",
              // borderTopRightRadius: "5px",
              // borderBottomRightRadius: "5px",
              // borderBottomLeftRadius: "5px",
              // overflowY: "auto"
            }}
          >
            <Button
              icon={<ArrowLeftOutlined />}
              style={{
                position: "absolute",
                height: "5px",
                fontSize: "15px",
                cursor: "pointer",
                top: "0px",
                left: "0px",
                zIndex: "1",
                border: "none",
              }}
              onClick={() => {
                // Handle the back button click event here
                setNestedModalOpen({
                  ...nestedModalOpen,
                  isUploadDocsModal: false,
                });
              }}
            >
              <text style={{ color: "gray", marginLeft: "5px" }}>Back</text>
            </Button>
            <div style={{ width: "100%" }}>
              <div style={{ display: "flex", width: "100%", fontSize: "15px" }}>
                <Tabs size="small"
                  defaultActiveKey="1"
                  style={{ width: "100%" }}
                  className="centered-tabs"
                  onChange={(key) => setTabSelect(key)}
                >
                  <TabPane
                    tab={<div style={{fontSize: '18px'}}>Create New</div>}
                    key={"1"}
                    style={{ width: "100%", height: "100%" }}
                    // disabled={role === "BUYER" ? true : false}
                  >
                    <CreateDocs role={role} item={item} section={section} handleCreateDocCancel={handleCreateDocCancel} loading={loading} userAuthKey={userAuthKey} />
                  </TabPane>
                  <TabPane
                    tab={<div style={{fontSize: '18px'}}>Upload</div>}
                    key={"2"}
                    style={{ width: "100%", height: "100%" }}
                  >
                  <div style={{width:"100%",margin:"auto",marginTop:"20px",display:"flex",justifyContent:"center"}}>
                  <DraggerComp
                    uploadFile={uploadFile}
                    isModalOpen={isModalOpen}
                    setNestedModalOpen={setNestedModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    uploadTemp={uploadTemp}
                    accept=".pdf,.PDF,image/*"
                    userAuthKey={userAuthKey}
                    />
                    </div>
                  </TabPane>
                <TabPane
                  tab={
                    <Button
                      style={{
                        background: "#3a74b6",
                        color: "whitesmoke",
                        fontWeight: "bold",
                        border: "none",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                        padding: "0 10px 0 0"
                      }}
                    >
                      <Image
                        style={{
                          objectFit: "contain",
                          width: "35px",
                          verticalAlign: "middle",
                        }}
                        src={ResureSign}
                        preview={false}
                      />
                      <span>RE-Sure Sign Docs</span>
                    </Button>
                  }
                  key={"5"}
                  style={{ width: "100%" }}
                >
                  {tabSelect === "5" && 
                  <ReSureSignDocs
                    setNestedModalOpen={setNestedModalOpen}
                    nestedModalOpen={nestedModalOpen}
                    propertyId={item?.propertyId}
                    offerId={!item?.isSellingMatrix ? item?.offerId : null}
                    RTDInitiator={"SELLER"}
                    isSellingMatrix={item?.isSellingMatrix}
                    handleCancel={handleCancel}
                    checkedDocs={checkedDocs}
                    setCheckedDocs={setCheckedDocs}
                    buyerAgentIds={buyerAgentIdsArray}
                    sellerAgentIds={sellerAgentIdsArray}
                    isWeb={isWeb}
                    delegate={
                      delegate && {
                        delegateSide: item?.isProperty ? "SELLER" : "BUYER",
                        delegateOwnerId: agentDetails?._id,
                      }
                    }
                    userAuthKey={userAuthKey}
                  />}
                </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </Modal>
      
    <SignableAndReadOnly role={tags} source={"SELLING_RTD"} selectedData={item}  isEmailModalVisible={nestedModalOpen} setIsEmailModalVisible={setNestedModalOpen}  userAuthKey={userAuthKey} allBuyerAgentData={allBuyerAgentData} formattedId={formattedId} />
    </>
  );
};

export { PropertyDocsModal };

